module.exports = __webpack_public_path__ + "static/media/sound2.2b01eee8.mp3";